module.exports = __webpack_public_path__ + "img/gjd.ee6e3fc1.svg";